// SECURITY: client→server handshake key for the OTP-send endpoint (sendVerificationSecureSms).
// This is a NON-secret app identifier — it necessarily ships in the client bundle. It MUST NOT be the
// JWT signing secret: the login forms previously sent encode(JWT_SECRET), which baked the real
// auth-signing secret into client.js (token forgery across web + besthand-api). Kept in a tracked
// file (config.js is gitignored/per-env) so client and server always agree on the same value.
// NOTE: a bundled key is weak by design — real hardening is server-side rate-limiting on OTP sends.
export const clientSmsKey = 'bh-web-client-otp-key-v1';
